import styled from 'styled-components';

import { useAuth } from '../../hooks/use-auth';

const Hero = styled.div`
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
  padding: 36px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: -0.01em;
`;

const Subtitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-family: ${({ theme }) => theme.font.secondary};
  font-size: 15px;
`;

const Badge = styled.span`
  align-self: flex-start;
  margin-bottom: 8px;
  padding: 4px 10px;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: ${({ theme }) => theme.colors.bgMuted};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const HomePage = () => {
  const { user } = useAuth();
  return (
    <Hero>
      <Badge>Fundação 01</Badge>
      <Title>Bem-vindo{user?.name ? `, ${user.name.split(' ')[0]}` : ''}.</Title>
      <Subtitle>
        Esta é a primeira versão do backoffice da Vendepay. Os próximos módulos
        de operação serão adicionados aqui conforme as próximas histórias
        avançarem.
      </Subtitle>
    </Hero>
  );
};
